import axios from 'axios'

export default {
  data () {
    return {
      count: '',
      filter: this.$route.query,
      data: null,
      searchParams: new URLSearchParams(),
      limit: 25,
      offset: 0,
      maxPages: 7,
      maxSize: [],
      page: 1,
      buffer: 3,
      searchParams_old: ''
    }
  },
  methods: {
    pressEnter () {
      this.installSpinner(true)
      this.getData()
    },
    getData () {
      this.installSpinner(true)
      for (let key in this.filter) {
        if (!this.filter[key]) {
          delete this.filter[key]
        }
      }
      if (this.defaultParams) {
        this.filter = Object.assign(this.filter, this.defaultParams)
      }
      this.$router.push({ query: this.filter })
      this.searchParams = new URLSearchParams()
      if (Object.keys(this.$route.query).length) {
        Object.keys(this.$route.query).forEach(key => {
          if (key !== 'created_date__lt' && key !== 'requested_at__lt') {
            this.searchParams.append(key, this.$route.query[key])
          } else {
            this.searchParams
              .append(
                key,
                this.$moment(this.filter[key === 'created_date__lt' ? 'created_date__lt' : 'requested_at__lt'], 'DD.MM.YYYY'
                )
                  .add(1, 'day')
                  .format('DD.MM.YYYY')
              )
          }
        })
      }

      let start = this.$moment(
        this.filter.created_date__gt
          ? this.filter.created_date__gt
          : this.filter.requested_at__gt,
        'DD.MM.YYYY'
      )
      let end = this.$moment(
        this.filter.created_date__lt
          ? this.filter.created_date__lt
          : this.filter.requested_at__lt,
        'DD.MM.YYYY'
      )

      this.page = 1
      let par1 = 1
      let par2 = 2 + this.buffer * 2

      if (this.searchParams_old !== this.filter) this.offset = 0
      axios
        .get(
          this.api +
          this.address +
          '&limit=' +
          this.limit +
          '&offset=0' +
          '&' +
          this.searchParams
        )
        .then(values => {
          this.count = values.data.count
          this.maxPages = Math.ceil(values.data.count / this.limit)
          this.maxSize = []
          for (
            let index = this.maxPages > 6 ? par1 : 1;
            index < (this.maxPages > 6 ? par2 : this.maxPages + 1);
            index++
          ) {
            this.maxSize.push(index)
          }
          this.setData(values.data.results)
          this.installSpinner(false)
          this.$refs.grid.dateFail = this.$moment(start).isAfter(this.$moment(end), 'days')
        }).catch(error => console.log(error))
    },
    getDataPage () {
      this.installSpinner(true)
      if (this.$refs.grid.spinnerON) this.$refs.grid.spinnerON = true
      this.page = this.offset !== 0 ? this.offset / 25 + 1 : 1
      let par1 = 0
      let par2 = 0
      if (
        this.page > this.buffer &&
        this.page < this.maxPages - this.buffer + 1
      ) {
        par1 = this.page - this.buffer
        par2 = this.page + this.buffer + 1
      } else {
        if (this.page <= this.buffer) {
          par1 = 1
          par2 = 2 + this.buffer * 2
        }
        if (this.page >= this.maxPages - this.buffer + 1) {
          par1 = this.maxPages - 2 * this.buffer
          par2 = this.maxPages + 1
        }
      }
      axios
        .get(
          this.api +
          this.address +
          '&limit=' +
          this.limit +
          '&offset=' +
          this.offset +
          '&' +
          this.searchParams
        )
        .then(values => {
          this.count = values.data.count
          this.maxPages = Math.ceil(values.data.count / this.limit)
          this.maxSize = []
          for (
            let index = this.maxPages > 6 ? par1 : 1;
            index < (this.maxPages > 6 ? par2 : this.maxPages + 1);
            index++
          ) {
            this.maxSize.push(index)
          }
          this.setData(values.data.results)
          this.installSpinner(false)
        })
    },
    find () {
      this.getData()
    },
    clear () {
      this.offset = 0
      this.filter = {}
      this.getData()
    },
    nextPage () {
      this.offset = this.offset + this.limit
      this.getDataPage()
    },
    prevPage () {
      this.offset = this.offset - this.limit
      this.getDataPage()
    },
    goToFirstPage () {
      this.offset = 0
      this.getDataPage()
    },
    goToLastPage () {
      this.offset = this.limit * (this.maxPages - 1)
      this.getDataPage()
    },
    goToPage (page) {
      this.offset = this.limit * (page - 1)
      this.getDataPage()
    },
    installSpinner (par) {
      if (!this.$refs.grid) {
        this.$refs.grid = { spinnerON: par }
      } else {
        this.$refs.grid.spinnerON = par
      }
      // console.log(this.$refs.grid.spinnerON)
    }
  },
  created () {
    this.getData()
    this.filter = {}
  }
}
